// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"_3_Ba_","breadcrumb":"_2TF9W","breadcrumbDivider":"_2gIyS","breadcrumbPath":"_22hhf","breadcrumbPage":"_3fU6E","sidebarBreadcrumbs":"_3d7eA _38618 _3_Ba_","sidebarBreadcrumb":"eVgJF _2TF9W"};


//////////////////
// WEBPACK FOOTER
// ./components/Breadcrumbs.css
// module id = 2041
// module chunks = 3